import React from 'react';
import TopUsersContainer from 'components/TopUsers/TopUsers';
import { Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

const TopUsers = props => (
  <React.Fragment>
    <Switch>
      <Route
        exact
        path={`/users/top-users/:topList`}
        render={() => (
          <Redirect
            from="/"
            to={`/users/top-users/${props.match.params.topList}/day`}
          />
        )}
      />
      <Route
        path="/users/top-users/:topList/:group"
        component={TopUsersContainer}
      />
    </Switch>
  </React.Fragment>
);

TopUsers.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      topList: PropTypes.string,
      group: PropTypes.string
    }).isRequired
  }).isRequired
};

export default TopUsers;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/TopUsers/TopUsers.js